module.exports = __webpack_public_path__ + "img/instagram.07a3c46.svg";